/**
 * Polyfill for `Array.prototype.at`, which does not exist on browsers older than
 * Chrome 92 / Safari 15.4 / Firefox 90. The embed uses `.at(-1)` (e.g. in the
 * analytics managers and date helpers), and on an outdated browser the missing
 * method throws `TypeError: ...at is not a function` mid-render, blanking the
 * embed. The guard makes this a no-op where `.at` already exists.
 */
if (typeof Array.prototype.at !== 'function') {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'at', {
    configurable: true,
    value: function at<T>(this: T[], index: number): T | undefined {
      const { length } = this;
      const relativeIndex = Math.trunc(index) || 0;
      const resolvedIndex =
        relativeIndex < 0 ? length + relativeIndex : relativeIndex;

      return resolvedIndex < 0 || resolvedIndex >= length
        ? undefined
        : this[resolvedIndex];
    },
    writable: true,
  });
}

export {};
